import * as React from 'react';

interface ImageProps {
    imageSrc: string;
    xPercent: number;
    yPercent: number;
    multipleZoomKey?: string;
    toggleZoom: (event?: any, index?: number) => void;
    onImageLoaded?: () => void;
    loading?: boolean;
    comparing?: boolean;
}

export class ZoomContainer extends React.Component<ImageProps, any> {
    constructor(props: ImageProps, context: any) {
        super(props, context);

        this.state = {
            zoomed: false,
            x_img_ele: 0,
            y_img_ele: 0
        };

        this.start_drag = this.start_drag.bind(this);
        this.while_drag = this.while_drag.bind(this);
        this.registerMouseDown = this.registerMouseDown.bind(this);
        this.registerMouseUp = this.registerMouseUp.bind(this);
        this.onImageLoaded = this.onImageLoaded.bind(this);
    }

    img_ele: HTMLElement;

    componentDidMount() {
        let key = this.props.multipleZoomKey ? `-${this.props.multipleZoomKey}` : '';
        document
            .getElementById(`drag-img${key}`)
            .addEventListener('mousedown', this.registerMouseDown);
        document
            .getElementById(`container${key}`)
            .addEventListener('mouseup', this.registerMouseUp);
        document
            .getElementById(`container${key}`)
            .addEventListener('mouseleave', this.registerMouseUp);
        document.getElementById(`container${key}`).addEventListener('mousemove', this.while_drag);
    }

    registerMouseDown(event: any) {
        this.setState({ mouseDown: true });
        this.start_drag(event);
    }

    registerMouseUp() {
        this.setState({ mouseDown: false });
    }

    render() {
        let key = this.props.multipleZoomKey ? `-${this.props.multipleZoomKey}` : '';
        return (
            <div
                id={`container${key}`}
                className={`zoom-container ${this.props.loading ? 'hide' : ''}`}
            >
                <img
                    className="drag-img"
                    onDoubleClick={this.props.toggleZoom}
                    onDragStart={this.onDragStart}
                    id={`drag-img${key}`}
                    src={this.props.imageSrc}
                    onLoad={this.onImageLoaded}
                />
            </div>
        );
    }

    onImageLoaded() {
        let key = this.props.multipleZoomKey ? `-${this.props.multipleZoomKey}` : '';

        this.img_ele = document.getElementById(`drag-img${key}`) as HTMLElement;
        let container = document.querySelector(
            `${this.props.comparing ? '.compare-container' : '#container'}`
        ) as HTMLElement;

        let imgWidth = this.img_ele['width'];
        let imgHeight = this.img_ele['height'];
        let maxWidth = container.offsetWidth - imgWidth;
        let maxHeight = container.offsetHeight - imgHeight;

        let left = imgWidth * this.props.xPercent * -1;
        let top = imgHeight * this.props.yPercent * -1;

        left += container.offsetWidth / 2;
        top += container.offsetHeight / 2;

        this.img_ele.style.left = Math.max(Math.min(left, 0), maxWidth) + 'px';
        this.img_ele.style.top = Math.max(Math.min(top, 0), maxHeight) + 'px';

        if (this.props.onImageLoaded) {
            this.props.onImageLoaded();
        }
    }

    onDragStart(e: React.DragEvent) {
        e.preventDefault();
    }

    start_drag(event: any) {
        let key = this.props.multipleZoomKey ? `-${this.props.multipleZoomKey}` : '';
        if (this.state.mouseDown) {
            this.img_ele = document.getElementById(`drag-img${key}`) as HTMLElement;
            let x_img_ele = event['clientX'] - document.getElementById(`drag-img${key}`).offsetLeft;
            let y_img_ele = event['clientY'] - document.getElementById(`drag-img${key}`).offsetTop;

            this.setState({ x_img_ele: x_img_ele, y_img_ele: y_img_ele });
        }
    }

    stop_drag() {
        this.img_ele = null;
    }

    while_drag(event: any) {
        let key = this.props.multipleZoomKey ? `-${this.props.multipleZoomKey}` : '';
        if (this.state.mouseDown) {
            let x_cursor = event['clientX'];
            let y_cursor = event['clientY'];
            if (this.img_ele !== null) {
                let imgHeight = this.img_ele['height'];
                let imgWidth = this.img_ele['width'];
                let maxWidth = document.getElementById(`container${key}`).offsetWidth - imgWidth;
                let maxHeight = document.getElementById(`container${key}`).offsetHeight - imgHeight;
                this.img_ele.style.left =
                    Math.max(Math.min(x_cursor - this.state.x_img_ele, 0), maxWidth) + 'px';
                this.img_ele.style.top =
                    Math.max(Math.min(y_cursor - this.state.y_img_ele, 0), maxHeight) + 'px';
            }
        }
    }
}

export default ZoomContainer;
